import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const DominicanRepublicFlagIcon: FC<PropsWithChildren<Props>> = ({
	className,
}) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_14609'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_14609)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 5.6H8.57143V0H0V5.6Z'
					fill='#083D7A'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M11.4277 14H19.9992V8.40002H11.4277V14Z'
					fill='#083D7A'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H8.57143V8.40002H0V14Z'
					fill='#DF1E35'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M11.4277 5.6H19.9992V0H11.4277V5.6Z'
					fill='#DF1E35'
				/>
				<mask
					id='path-7-inside-1_2332_14609'
					fill='white'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M8.99062 6.01005C8.43273 6.55678 8.43273 7.44322 8.99062 7.98995C9.54851 8.53668 10.453 8.53668 11.0109 7.98995C11.5688 7.44322 11.5688 6.55678 11.0109 6.01005'
					/>
				</mask>
				<path
					d='M8.51448 5.54343C7.69362 6.34787 7.69362 7.65213 8.51448 8.45657L9.46676 7.52333C9.17184 7.2343 9.17184 6.7657 9.46676 6.47667L8.51448 5.54343ZM8.51448 8.45657C9.33534 9.26101 10.6662 9.26101 11.4871 8.45657L10.5348 7.52333C10.2399 7.81236 9.76169 7.81236 9.46676 7.52333L8.51448 8.45657ZM11.4871 8.45657C12.3079 7.65213 12.3079 6.34787 11.4871 5.54343L10.5348 6.47667C10.8297 6.7657 10.8297 7.2343 10.5348 7.52333L11.4871 8.45657Z'
					fill='#0F6D1A'
					mask='url(#path-7-inside-1_2332_14609)'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M9.99963 7.46666C10.2626 7.46666 10.4758 7.25772 10.4758 6.99999C10.4758 6.74226 10.2626 6.53333 9.99963 6.53333C9.73664 6.53333 9.52344 6.74226 9.52344 6.99999C9.52344 7.25772 9.73664 7.46666 9.99963 7.46666Z'
					fill='#042F60'
				/>
			</g>
		</svg>
	);
};

export default DominicanRepublicFlagIcon;
